import { render } from "./WhoIsDrAafia.vue?vue&type=template&id=1770110f&scoped=true"
import script from "./WhoIsDrAafia.vue?vue&type=script&lang=js"
export * from "./WhoIsDrAafia.vue?vue&type=script&lang=js"

import "./WhoIsDrAafia.vue?vue&type=style&index=0&id=1770110f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1770110f"]])

export default __exports__